<template>
  <div class="mobileA-page" :class="{ ios: os.isPhone }">
    <div class="m-viewport">
      <!-- 背景：始终全屏占满，不随舞台缩放 -->
      <img class="m-bg" src="@/assets/images/mobile/a/bg.webp" alt="" />
      <div class="m-stage">
        <!-- 顶栏 logo -->
        <div class="m-topbar">
          <img
            class="m-logo"
            src="@/assets/images/mobile/a/top-bar.webp"
            alt=""
          />
          <!-- 联系方式图标 -->
          <img
            v-for="(c, i) in layout.contacts"
            :key="'c' + i"
            v-show="contactUrls[i]"
            class="m-contact"
            :src="c.img"
            :style="posStyle(c)"
            alt=""
            @click.stop="toPage(contactUrls[i])"
          />
        </div>

        <!-- 人物渐入渐出（整帧交叉淡入，底层常驻 + 顶层淡入） -->
        <img class="m-state m-state-base" :src="states[baseIdx]" alt="" />
        <img
          class="m-state m-state-top"
          :src="states[topIdx]"
          :style="{ opacity: topOpacity }"
          alt=""
        />

        <!-- 主区域 -->
        <div class="m-main">
          <!-- slogan / 卖点 -->
          <img src="@/assets/images/mobile/a/slogan.webp" alt="" />

          <!-- 主下载按钮 -->
          <img
            class="m-clickable"
            src="@/assets/images/mobile/a/download.webp"
            alt=""
            @click.stop="getApkInfo(os.isPhone ? 'ios' : 'android', $event)"
          />

          <!-- 官方域名：点击复制域名 -->
          <img
            class="m-domain"
            src="@/assets/images/mobile/a/domain.webp"
            alt=""
            @click.stop="copyDomain"
          />
        </div>

        <!-- 底部固定栏：整条 banner 即立即下载入口 -->
        <div
          class="m-bottom"
          @click.stop="getApkInfo(os.isPhone ? 'ios' : 'android', $event)"
        >
          <img
            class="m-abs"
            src="@/assets/images/mobile/a/bottom-tips.webp"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- 安卓提示框 -->
    <van-overlay :show="androidPromptShow" z-index="999" class="androidOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="androidPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <!-- 苹果提示框 -->
    <van-overlay :show="iosPromptShow" z-index="999" class="iosOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="appName">快看涩漫</div>
          <div class="desc">精选全网优质动漫资源</div>
          <div class="confirmBtnBox" @click="iosPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">
        请使用Safari浏览器进行下载
      </div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import { landingPageClick } from "@/utils/eventTracker";

export default {
  name: "MobileA",
  props: ["os", "configs", "switchData"],
  data() {
    return {
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      autoDownloadTriggered: false,
      currUrl: window.location.href,
      // 点击域名图复制的官方域名
      officialDomain: "kksm.app",
      // 人物两套素材，交叉淡入切换（参照 pcA）
      states: [
        require("@/assets/images/mobile/a/state1.webp"),
        require("@/assets/images/mobile/a/state2.webp")
      ],
      baseIdx: 0,
      topIdx: 1,
      topOpacity: 0,
      xfadeTimer: null,
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: "",
      layout: {
        contacts: [
          {
            right: 110,
            top: 8,
            w: 26,
            h: 42,
            img: require("@/assets/images/mobile/a/bar-sw.webp")
          },
          {
            right: 60,
            top: 8,
            w: 26,
            h: 42,
            img: require("@/assets/images/mobile/a/bar-qd.webp")
          },
          {
            right: 10,
            top: 8,
            w: 26,
            h: 42,
            img: require("@/assets/images/mobile/a/bar-qz.webp")
          }
        ],
        slogan: { left: 1, top: 320, w: 375 },
        download: { left: 36, top: 520, w: 304 },
        domain: { left: 97, top: 588, w: 183 },
        bottom: { left: 0, top: 694, w: 375 }
      }
    };
  },
  computed: {
    contactUrls() {
      return [this.swUrl, this.qdUrl, this.tgUrl];
    }
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
      });
      return newValue;
    },
    switchData: {
      immediate: true,
      handler() {
        this.tryAutoDownload();
      }
    }
  },
  mounted() {
    if (!this.checkIsSafari() && this.os.isPhone) {
      this.showTip = true;
    }
    const referrer = sessionStorage.getItem("referrer");
    const dc = sessionStorage.getItem("dc");
    if (referrer && dc) {
      this.currUrl = referrer + "user.html?dc=" + dc;
    } else {
      if (referrer) {
        this.currUrl = referrer + "user.html";
      } else {
        this.currUrl = window.location.href;
      }
    }
    this.states.forEach(src => {
      new Image().src = src;
    });
    // 安装教程弹窗背景藏在未展开的 overlay 里不会自动拉取，
    // 预加载避免弹出时正赶上下载跳转、请求被中断导致弹窗空白
    new Image().src = require("@/assets/images/mobile/iosTip.png");
    new Image().src = require("@/assets/images/mobile/androidTip.png");
    this.startRotation();
  },
  beforeDestroy() {
    this.stopRotation();
  },
  methods: {
    posStyle(o) {
      const s = {
        left: o.left + "px",
        top: o.top + "px",
        width: o.w + "px",
        right: o.right + "px"
      };
      if (o.h != null) s.height = o.h + "px";
      return s;
    },
    startRotation() {
      this.stopRotation();
      this.xfadeTimer = setInterval(() => {
        const next = (this.baseIdx + 1) % this.states.length;
        this.topIdx = next;
        this.topOpacity = 0;
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.topOpacity = 1;
          });
        });
        setTimeout(() => {
          this.baseIdx = next;
          this.topOpacity = 0;
        }, 850);
      }, 3000);
    },
    stopRotation() {
      if (this.xfadeTimer) {
        clearInterval(this.xfadeTimer);
        this.xfadeTimer = null;
      }
    },
    // 剪贴板
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          this.showTip = false;
        },
        () => {}
      );
    },
    // 复制官方域名；.stop 阻止冒泡，避免外层归因复制把域名覆盖掉
    copyDomain() {
      this.$copyText(this.officialDomain).then(
        () => {
          this.$toast("已复制官方域名");
        },
        () => {
          this.$toast("复制失败，请手动输入 " + this.officialDomain);
        }
      );
    },
    checkIsSafari() {
      let ua = (this.os.userAgent || "").toLowerCase();
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1
      );
    },
    // 下载数据就绪后，按当前系统自动触发一次下载
    tryAutoDownload() {
      if (this.autoDownloadTriggered) return;
      const data = this.switchData || {};
      const isIos = this.os.isPhone;
      const downUrl = isIos ? data.iosDownUrl : data.channelApkAndDownUrl;
      if (!downUrl) return;
      if (isIos && !this.checkIsSafari()) return;
      this.autoDownloadTriggered = true;
      this.fireWhenPageLoaded(() => {
        this.getApkInfo(isIos ? "ios" : "android", null, 5000);
      });
    },
    fireWhenPageLoaded(fn) {
      if (document.readyState === "complete") {
        fn();
        return;
      }
      let fired = false;
      const fire = () => {
        if (fired) return;
        fired = true;
        window.removeEventListener("load", fire);
        fn();
      };
      window.addEventListener("load", fire);
      setTimeout(fire, 10000);
    },
    async showInstallTutorial(type) {
      if (type == "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async getApkInfo(type, event, tutorialDelay = 0) {
      this.$toast("应用正在下载中，十秒后无反应请再次点击下载！");
      if (tutorialDelay) {
        setTimeout(() => {
          this.showInstallTutorial(type);
        }, tutorialDelay);
      } else {
        await this.showInstallTutorial(type);
      }
      this.$emit("recordClick", type);
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      if (!event) return;
      let click_coordinates_x = event.clientX;
      let click_coordinates_y = event.clientY;
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x,
        click_coordinates_y
      });
    },
    toPage(path) {
      if (path) window.open(path);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.mobileA-page {
  height: 100%;
  width: 100%;
  background: #180a34;
  .m-viewport {
    position: relative;
    width: 100%;
    height: 100dvh;
    min-height: 100%;
    overflow: hidden;
  }
  .m-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }
  .m-stage {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 375px;
    height: 100dvh;
    transform: translate(-50%, -50%);
    transform-origin: center center;
    z-index: 1;
  }
  .m-topbar {
    position: absolute;
    left: 0;
    top: 0;
    width: 375px;
    z-index: 5;
    .m-logo {
      width: 100%;
    }
    .m-contact {
      position: absolute;
    }
  }
  .m-state {
    position: absolute;
    inset: 0;
    width: 375px;
    height: 768px;
    object-fit: cover;
  }
  .m-main {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    bottom: 100px;
    .m-clickable {
      width: 288px;
      height: 73px;
    }
    .m-domain {
      width: 183px;
      height: 30px;
      cursor: pointer;
    }
    img {
      width: 100%;
    }
  }
  .m-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    cursor: pointer;
    .m-abs {
      width: 100%;
    }
  }

  .m-clickable {
    cursor: pointer;
  }
}

.androidOverlay {
  display: flex;
  align-items: center;
  justify-content: center;

  .overlayContent {
    width: 297px;
    height: 441px;
    border-radius: 12px;
    padding-top: 380px;
    background: url("../../../../assets/images/mobile/androidTip.png") no-repeat;
    background-size: 100% 100%;
    .confirmBtnBox {
      height: 36px;
      width: 140px;
      border-radius: 40px;
      margin: 0 auto;
    }
  }
}

.iosOverlay {
  display: flex;
  align-items: center;
  justify-content: center;

  .overlayContent {
    width: 297px;
    height: 441px;
    background-size: 100% 100%;
    border-radius: 12px;
    padding-top: 380px;
    position: relative;
    background: url("../../../../assets/images/mobile/iosTip.png") no-repeat;
    background-size: 100% 100%;
    .appName {
      font-size: 10px;
      font-weight: 500;
      color: #242423;
      position: absolute;
      left: 79px;
      bottom: 102px;
      z-index: 1;
      background-color: #ffffff;
      width: 100px;
    }

    .desc {
      font-size: 7px;
      font-weight: 500;
      color: #8f908f;
      position: absolute;
      left: 79px;
      bottom: 92px;
      z-index: 1;
      background-color: #ffffff;
      width: 100px;
    }

    .confirmBtnBox {
      height: 36px;
      width: 140px;
      border-radius: 40px;
      margin: 0 auto;
    }
  }
}

.downTip {
  border-radius: 10px;
  padding: 18px;
  box-sizing: border-box;
  text-align: center;

  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }

  .downTipContent {
    white-space: nowrap;
    font-size: 15px;
  }

  .url {
    font-size: 15px;
    margin-top: 16px;
    text-align: left;
  }

  .downTipConfirm {
    font-size: 15px;
    width: 160px;
    height: 30px;
    border-radius: 40px;
    margin: 32px auto 0;
    color: #fff;
    background: #5b92ee;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
